import { render, staticRenderFns } from "./LanguageList.vue?vue&type=template&id=0a3b29ef&scoped=true&"
import script from "./LanguageList.vue?vue&type=script&lang=js&"
export * from "./LanguageList.vue?vue&type=script&lang=js&"
import style0 from "./LanguageList.vue?vue&type=style&index=0&id=0a3b29ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b29ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VLayout,VTooltip})
